import StudentAllFormInfo from "./src/main";

/* istanbul ignore next */
StudentAllFormInfo.install = function (Vue) {
  Vue.component(StudentAllFormInfo.name, StudentAllFormInfo);
};

export default StudentAllFormInfo;
